// Libraries
import { Box, Button, Card, CardActions, CardContent, Divider, TextField, Typography } from "@mui/material";
import clsx from "clsx";
import { useState } from "react";

type TReasonCardProps = {
	buttonText: string;
	className?: string;
	amountSelected: number;
	onClick: (reason: string) => void;
	onClickAway: () => void;
};

const maxLetters = 500;

export default function ReasonCard(props: Readonly<TReasonCardProps>) {
	const { amountSelected, buttonText, className = "", onClick, onClickAway } = props;
	const [reason, setReason] = useState("");

	function onClickHandler() {
		onClick(reason);
		onClickAway();
	}

	function onChangeReason(value: string) {
		if (value.length <= maxLetters) {
			setReason(value);
		}
	}

	return (
		<Card
			className={clsx({ "absolute w-[279px] min-h-[149px] !shadow-card-gray max-h-screen z-[1000]": true, [`${className}`]: true })}
		>
			<CardContent className="!pb-0">
				<TextField
					multiline
					minRows={3}
					maxRows={5}
					variant="standard"
					placeholder={`This reason will apply to all (${amountSelected}) selected pending requests...`}
					fullWidth
					value={reason}
					onChange={(e) => onChangeReason(e.target.value)}
					sx={{
						"& .MuiInput-underline:before": { display: "none" },
						"& .MuiInput-underline:after": { display: "none" },
						"& .MuiInput-underline:hover:before": { display: "none" },
						"& .MuiInput-underline:hover:after": { display: "none" },
					}}
				/>
				<Divider />
				<Box component={"span"} className="font-sans text-[12px] text-default">{`${reason.length}/${maxLetters}`}</Box>
			</CardContent>
			<CardActions className="flex justify-end !pt-[0px] !pr-4 !pb-4">
				<Button
					variant="contained"
					aria-controls="select-plan-dialog-assign-btn-menu"
					className={clsx({
						"h-[30px] w-[80px] !rounded-[6px] hover:!shadow-gray-blue !shadow-none": true,
						"!bg-gray-blue": reason,
						"!bg-disabled": !reason,
					})}
					onClick={onClickHandler}
					disabled={!reason}
				>
					<Typography className="change-request-btn-text">{buttonText}</Typography>
				</Button>
			</CardActions>
		</Card>
	);
}
